<template>
  <div>
    <div class="comp-header" :class="headerPosition">
      <comp-header-left
        :PDLIcon="leftIcon"
        :PDLLink="leftLink"
        :PDLBadge="leftBadge"
        :PDLClick="leftClick"
      >
      </comp-header-left>
      <comp-header-right
        :PDRIcon="rightIcon"
        :PDRLink="rightLink"
        :PDRBadge="rightBadge"
        :PDRBadgeSub="rightSubBadge"
        :PDRSubIcon="rightSubIcon"
        :PDRClick="rightClick"
        :PDRSubClick="rightSubClick"
      >
      </comp-header-right>
      <comp-header-title :PDTitle="pageTitle"> </comp-header-title>
    </div>
  </div>
</template>

<script>
import CompHeaderLeft from './CompHeaderLeft';
import CompHeaderRight from './CompHeaderRight';
import CompHeaderTitle from './CompHeaderTitle';

export default {
  props: {
    headerPosition: String,
    leftIcon: String,
    leftLink: String,
    leftBadge: String,
    rightIcon: String,
    rightLink: String,
    rightBadge: String,
    rightSubBadge: String,
    rightSubIcon: String,
    pageTitle: String,
    leftClick: Function,
    rightClick: Function,
    rightSubClick: Function,
  },
  data() {
    return {};
  },
  components: {
    'comp-header-left': CompHeaderLeft,
    'comp-header-right': CompHeaderRight,
    'comp-header-title': CompHeaderTitle,
  },
};
</script>

<style lang="scss" src="../scss/comp-header.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompHeader.vue